<template>
    <div v-if="!disabled">
        <a v-if="count > 0 && !disableCount" :href="url" @click="gotoJingleBox" class="btn jinglebox-cta">{{ window.t('explore_jinglebox') }}<span> ({{ count }})</span></a>
        <a v-else class="btn black jinglebox-cta" href="#" @click.prevent="openWebsiteAssistent">{{ window.t('general_explore') }}</a>
    </div>
</template>
<script>
    export default {
        props: {
            disabled: {
                type: Boolean,
                required: true,
            },
            url: {
                type: String,
                required: true,
            },
            initCount: {
                type: Number,
                default: 0,
            },
            disableCount: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                window,
                count: 0,
            };
        },
        async mounted() {
            this.count = this.initCount;
            this.$root.$on('jingleboxCount', count => this.count = count);
        },
        methods: {
            openWebsiteAssistent() {
                _gte('click', {
                    'event_category': document.title,
                    'event_label':  window.t('general_explore')
                });
                window.openWebsiteAssistent();
            },
            gotoJingleBox() {
                _gte('open_information', {
                    'event_category': document.title,
                    'event_label':  window.t('explore_jinglebox')
                });
            }
        }
    }
</script>
